module.exports = __webpack_public_path__ + "img/back.c8ec7ff7.svg";